import React from "react";
import { Column, ColumnId } from ".";
import PickupSettlementCellContent from "../components/PickupSettlementCellContent";
import base from "./base";

function pickupSettlement({ width, onResize }: Column.Options) {
	return base(
		ColumnId.PickupSettlement,
		(item) => <PickupSettlementCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default pickupSettlement;
